require('./loanSettlements.scss');
const PropTypes = require('prop-types');
// @ vendors
const React = require('react');
const { connect } = require('react-redux');
const classNames = require('classnames');
const PureRenderMixin = require('react-addons-pure-render-mixin');
// @ helpers
const { formatText, FormattedText, getLanguage } = require('core/i18n').i18n;
// @ components
const LoanSettlementsFilter = require('../loanSettlementsFilter/loanSettlementsFilter');
const LoanSettlementsHeader = require('../loanSettlementsHeader/loanSettlementsHeader');
const LoanSettlementsRow = require('../loanSettlementsRow/loanSettlementsRow');
const LoanSettlementsDetailRow = require('../loanSettlementsDetailRow/loanSettlementsDetailRow');
const LoanCollectiveTag = require('../../loanCollectiveTag/loanCollectiveTag');
// @ commons
const { LastMovementsTable } = require('commonsComponents/lastMovementsTable');
const { EmptyState } = require('commonsComponents/emptyState');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');
// @ actions
const {
    requestNextPage,
    requestLoanSettlements,
    setFilters,
    clearFitlers
} = require('../../../../actions/loanSettlements');
// @ constants
const { LAST_MOVEMENTS_TABLE_CURRENT_MONTH_KEY } = require('constants/commonsComponents');
const language = getLanguage();

class LoanSettlements extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            filtersOpen: false,
            expandedRowId: ''
        };

        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
        this.buildTable = this.buildTable.bind(this);
        this.handleClearFilters = this.handleClearFilters.bind(this);
        this.handleNextPage = this.handleNextPage.bind(this);
        this.handleRowClick = this.handleRowClick.bind(this);
        this.handleSetFilters = this.handleSetFilters.bind(this);
        this.handleToggleFilters = this.handleToggleFilters.bind(this);
        this.handleRequestData = this.handleRequestData.bind(this);
    }

    buildContent() {
        const { immLoanSettlements } = this.props;
        const isLoading = immLoanSettlements.get('isFetching');
        const hasError = immLoanSettlements.get('error');
        const isEmpty = immLoanSettlements.get('byOrder').isEmpty();
        let content;

        if (isLoading) {
            content = <LoadingSection />;
        } else if (hasError) {
            content = this.buildEmptyState('loanSettlements-errorMessage', 'nointernet-banking', true);
        } else if (isEmpty) {
            content = this.buildEmptyState('loanSettlements-emptyState', 'noitems-banking');
        } else {
            content = this.buildTable();
        }

        return content;
    }

    buildEmptyState(messageKey, iconType, showButton = false) {
        const primaryText = formatText(messageKey);
        let retryButton;

        if (showButton) {
            retryButton = (
                <OKButton onClick={this.handleRequestData} >
                    <FormattedText value="common-retry" />
                </OKButton>
            );
        }

        return (
            <EmptyState
                primaryText={primaryText}
                button={retryButton}
                iconType={iconType} />
        );
    }

    buildBadge() {
        const { immLoan } = this.props;

        return (
            <LoanCollectiveTag
                extraClass="loan-settlements__collective-tag"
                immLoan={immLoan}
            />
        );
    }

    buildHeader() {
        const { immFilters } = this.props;
        const title = formatText('loanSettlements-title');
        const badge = this.buildBadge();

        let allOrClearElement = formatText('loanSettlements-all');
        const headerClasses = classNames('loan-settlements__header',
            {
                'loan-settlements__header--has-filters': immFilters.get('isActive')
            }
        );
        let filterLabels;
        if (immFilters.get('isActive')) {
            allOrClearElement = (
                <button
                    id="btn_loanSettlements_clearFilters"
                    className="loan-settlements__button-clean"
                    onClick={this.handleClearFilters}
                >
                    <FormattedText value="filters-clear" format="uppercase" />
                </button>
            );

            filterLabels = <LoanSettlementsHeader immFilter={immFilters} />
        }
        let modal;
        if (this.state.filtersOpen) {
            modal = (
                <LoanSettlementsFilter
                    immFilter={immFilters}
                    onSetFilters={this.handleSetFilters}
                    onCloseClick={this.handleToggleFilters}
                />
            );
        }

        return (
            <section className={headerClasses}>
                <OKBoxTitle value={title} />
                <div className="loan-settlements__header-filters pull-right">
                    {badge}
                    <span className="loan-settlements__header-filters-text">
                        {allOrClearElement}
                    </span>
                    <OKButton
                        id="btn_loan-settlements-filter"
                        modifier="task"
                        onClick={this.handleToggleFilters}
                    >
                        <i className="icon-filtrar" />
                    </OKButton>
                </div>
                {modal}
                {filterLabels}
            </section>
        );
    }

    buildNextPageButton() {
        const { immLoanSettlements } = this.props;
        let content;

        if (immLoanSettlements.get('nextPage')) {
            if (immLoanSettlements.get('isFetchingNextPage')) {
                content = <LoadingSection />;
            } else {
                content = (
                    <div className="loan-settlements__more-movements">
                        <OKButton modifier="link-complementary" onClick={this.handleNextPage}>
                            <FormattedText value="loanSettlements-moreSettlements" />
                        </OKButton>
                    </div>
                );
            }
        }

        return content;
    }

    buildTable() {
        const { immLoanSettlements } = this.props;
        const nextPageButton = this.buildNextPageButton();

        return (
            <div>
                <LastMovementsTable
                    groupByDate={false}
                    rowComponent={LoanSettlementsRow}
                    immTransactionsByOrder={immLoanSettlements.get('byOrder')}
                    immTransactionsById={immLoanSettlements.get('byId')}
                    columnsCount={5}
                    groupHeaderClassName={'loan-settlements__group-header'}
                    expandedRowId={this.state.expandedRowId}
                    expandedRowComponent={LoanSettlementsDetailRow}
                    onRowClick={this.handleRowClick}
                    id="loan-settlements-table"
                    className="loan-settlements__table"
                    currentMonthKey={LAST_MOVEMENTS_TABLE_CURRENT_MONTH_KEY}
                    language={language}
                >
                    <thead>
                        <OKTableRow asHeader={true}>
                            <OKTableCell asHeader={true}>
                                <span></span>
                            </OKTableCell>
                            <OKTableCell asHeader={true}>
                                <FormattedText value="loanSettlements-startDate" />
                            </OKTableCell>
                            <OKTableCell asHeader={true}>
                                <FormattedText value="loanSettlements-endDate" />
                            </OKTableCell>
                            <OKTableCell asHeader={true}>
                                <FormattedText value="loanSettlements-debitAmount" />
                            </OKTableCell>
                            <OKTableCell asHeader={true}>
                                <FormattedText value="loanSettlements-creditAmount" />
                            </OKTableCell>
                        </OKTableRow>
                    </thead>
                </LastMovementsTable>
                {nextPageButton}
            </div>
        );
    }

    handleClearFilters() {
        const { clearFitlers } = this.props;
        clearFitlers();
        this.handleRequestData();
    }

    handleNextPage() {
        this.props.requestNextPage(this.props.loanId);
    }

    handleRequestData() {
        const { loanId, requestLoanSettlements } = this.props;
        requestLoanSettlements(loanId);
    }

    handleRowClick(id) {
        this.setState({
            expandedRowId: id === this.state.expandedRowId ? '' : id
        });
    }

    handleSetFilters(filters) {
        const { setFilters, loanId } = this.props;
        setFilters(filters, loanId);
        this.handleRequestData();
    }

    handleToggleFilters() {
        this.setState({
            filtersOpen: !this.state.filtersOpen
        });
    }

    render() {
        const header = this.buildHeader();
        const content = this.buildContent();

        return (
            <OKSectionBox className="loan-settlements">
                {header}
                {content}
            </OKSectionBox>
        );
    }
}

LoanSettlements.propTypes = {
    immFilters: PropTypes.object.isRequired,
    immLoan: PropTypes.object.isRequired,
    immLoanSettlements: PropTypes.object.isRequired,
    requestNextPage: PropTypes.func.isRequired,
    requestLoanSettlements: PropTypes.func.isRequired,
    setFilters: PropTypes.func.isRequired,
    clearFitlers: PropTypes.func.isRequired,
    loanId: PropTypes.string.isRequired
};

module.exports = connect(null, {
    requestNextPage,
    requestLoanSettlements,
    setFilters,
    clearFitlers
})(LoanSettlements);
